<template>
  <SeatingDataProvider
    v-slot="{ mySeat, guestSeats, hasGuests, hasSeating, loading, failed }"
  >
    <!-- Nothing at all on events without a seating plan, and nothing while the
         request is in flight or after it failed — an empty answer and a failed
         one look alike here, and only the first one may be reported as "not
         assigned yet". -->
    <div v-if="hasSeating && !loading && !failed" class="w-full">
      <!-- The label sits in the same left-hand column the row icons occupy, and
           inherits the panel's centring like they do, so it lines up over the
           chair icon instead of hanging off the panel's left edge. Same text
           size as the rest of the block — it is a label, not a title. -->
      <div class="flex flex-row w-full mb-2">
        <div class="w-2/5 text-xxs md:text-xs lg:text-sm">
          {{ $t('Views.Stage.MyProfile.seatingArrangement') }}
        </div>
      </div>

      <div class="flex flex-row items-start w-full">
        <div class="w-2/5">
          <i class="fal fa-chair fa-sm md:fa-lg lg:fa-2x" />
        </div>
        <div class="w-3/5 space-y-3">
          <span
            class="text-xxs md:text-xs lg:text-sm"
            v-text="seatText(mySeat)"
          />

          <div v-if="hasGuests" class="space-y-2">
            <div class="text-xxs md:text-xs lg:text-sm font-bold">
              {{ $t('Views.Stage.MyProfile.myGuests') }}
            </div>
            <div v-for="(guest, index) in guestSeats" :key="index">
              <div
                class="text-xxs md:text-xs lg:text-sm"
                v-text="guestName(guest, index)"
              />
              <div
                class="text-xxs md:text-xs lg:text-sm opacity-75"
                v-text="seatText(guest)"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </SeatingDataProvider>
</template>

<script>
import seatingFormat from '@/mixins/seatingFormat';

export default {
  name: 'SeatingInfo',
  mixins: [seatingFormat]
};
</script>
